<template>
  <AiEntry
    :title="title"
    :content="suggestion"
    has-ai-text
    can-retry
    :is-loading="isLoading"
    @onUseSuggestion="approve"
    @onRetry="retry"
    @onCancel="cancel"
  />
</template>

<script>
import { getCorrectLocaleName } from '@/helpers/localeHelper'
import aiService from '@/service/ai.service'
import AiEntry from './AiEntry.vue'

export default {
  components: {
    AiEntry,
  },
  props: {
    locale: {
      type: Object,
      required: true,
      default: () => {},
    },

    fieldName: {
      type: String,
      required: false,
      default: '',
    },

    text: {
      type: String,
      required: true,
    },
  },

  emits: ['onCancel', 'onApprove'],
  data() {
    return {
      suggestion: '',
      isLoading: false,
    }
  },

  computed: {
    title() {
      const translatedLocaleName = getCorrectLocaleName(this.locale)

      return this.$t('ai.NEW_SUGGESTED_LOCALE_FIELDNAME', {
        localeName: translatedLocaleName,
        fieldName: this.fieldName,
      })
    },
  },

  async mounted() {
    await this.setSuggestion(this.text)
  },

  methods: {
    cancel() {
      this.$emit('onCancel')
    },

    async retry() {
      await this.setSuggestion(this.text, this.suggestion)
    },

    approve() {
      this.$emit('onApprove', this.suggestion)
    },

    async setSuggestion(text, oldText = undefined) {
      this.isLoading = true

      try {
        const response = await aiService.getShortenAi(text, oldText)
        this.suggestion = response.data.text
      } catch (error) {
        this.$toast({ text: error }, { displayDuration: 5000, theme: 'error' })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
